export class CfetButtonLabelsConstant {
    public static CFET_BUTTON_LABELS = {
        button_labels: {
            yes: 'Yes',
            no: 'No',
            continue: 'Continue',
            continue_without_code: 'Continue without code',
            cancel: 'Cancel',
            use1ID: 'Use 1 ID',
            getStarted: 'Get started',
            close: 'Close',
            delete: 'Delete',
            signup: 'Sign up',
            completeProfile: 'Complete profile',
            upload: 'Add photo',
            uploading: 'Uploading…',
            uploadAnother: 'Add another',
            done: 'Done',
            skip: 'Skip for now',
            skip_photo_upload: 'Skip photo upload',
            skip_photo_upload_utf: 'Skip upload',
            utf_upload: 'Upload Documents',
            utf_uploadAnother: 'Upload another document',
            utf_skip: 'Skip Upload',
            submit: 'Submit',
            employee: 'Employee',
            volunteer: 'Volunteer',
            continueToProfile: 'Continue to profile',
            camera: 'Camera',
            photos: 'Photos',
            documentVerification: 'Upload Documents',
            ok: 'Ok',
            shopNow: 'Shop now',
            Shop_for_FirstNet : 'Shop for FirstNet services',
            changePlan: 'Change plan',
            stayhere: 'Stay here',
            stay: 'Stay',
            keep: 'Keep working',
            cancelapplication: 'Cancel application',
            back: 'Back',
            go_back: 'Go back to FirstNet home',
            utf_go_back: 'Go back',
            utf_submit: 'Submit',
            utf_cancel_application: 'Leave',
            utf_single_id: 'Use 1 ID',
            continue_with_affCode: 'Yes, Associate My Account',
            continue_without_affCode: 'No, Continue Without Association',
        }
    };
}
